import { render } from "./PatientReviews.vue?vue&type=template&id=71d0f197"
import script from "./PatientReviews.vue?vue&type=script&lang=js"
export * from "./PatientReviews.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__